module.exports = __webpack_public_path__ + "static/completedview-f6bb1c267af5b6accde19928e0b3cc50.png";